import { render, staticRenderFns } from "./SidebarHeader.vue?vue&type=template&id=1f4131ba&scoped=true"
import script from "./SidebarHeader.vue?vue&type=script&lang=js"
export * from "./SidebarHeader.vue?vue&type=script&lang=js"
import style0 from "./SidebarHeader.vue?vue&type=style&index=0&id=1f4131ba&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4131ba",
  null
  
)

export default component.exports